<style scoped>
input {
  border: 1px solid #ced4da;
}

.loader {
  height: 100px;
  width: 100%;
  text-align: center;
  padding: 1em;
  display: inline-block;
  vertical-align: top;
  z-index: 20;
  position: absolute;
  margin: 100px auto;
}

.display-pdfs {
  font-size: 13px;
  padding-left: 3px;
}

.attachment-heading {
  font-weight: bold;
  font-size: 15px;
}

.display-pdfs:not(:first-child) {
  padding-top: 5px;
}

/*
  Set the color of the icon
*/

svg path,
svg rect {
  fill: #0162A7;
}
</style>
<style>
.dropdown-menu {
  top: 0px !important;
  left: 0px !important;
}

#customdropzone {
  min-height: 30px;
  overflow: hidden;
  padding: 0px;
  border: 0px solid grey;
}

#customdrozpne:hover {
  background-color: white;
}

#customdropzone .dz-details {
  background-color: transparent;
  color: black;
  padding: 5px;
  opacity: 1;
}

#customdropzone .dz-preview {
  margin: 0 !important;
  width: 100%;
  display: inline-block;
  min-height: 30px;
  background-color: white !important;
}

#customdropzone .dz-preview .dz-file-preview {
  height: 30px;
}

#customdropzone .dz-preview .dz-progress {
  border-radius: 0;
  margin-left: 0px;
  margin-top: -10px;
  width: 150px;
  position: absolute;
  background-color: white;
  border: 1px solid grey;
}

#customdropzone .dz-remove {
  opacity: 1 !important;
  margin-top: 10px;
  position: absolute;
  right: 50px;
  z-index: 30;
  color: grey;
  border: 0;
  text-decoration: none;
  font-size: .8rem;
  font-weight: 300;
  letter-spacing: 1.1px;
}

.loading {
  opacity: 0.5;
  pointer-events: none;
}

.wrapper {
  position: relative;
}

.vue-tags-input {
  height: auto !important;
  max-width: 100% !important;
}

.ti-input {
  border: 0 !important;
  padding: 0 !important;
}

.pick-email-field {
  cursor: pointer;
}

.remove-attachments {
  cursor: pointer;
  margin-left: 10px;
}

</style>
<script>
import axios from 'axios';
import 'bootstrap-select';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import vueDropzone from "vue2-dropzone";
import VueTagsInput from '@johmun/vue-tags-input';

import 'tinymce/themes/silver/theme';
import 'tinymce/skins/ui/oxide/skin.min.css';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/link';
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/image';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/print';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/code';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/insertdatetime';
import 'tinymce/plugins/media';
import 'tinymce/plugins/table';
import 'tinymce/plugins/imagetools';
import Editor from '@tinymce/tinymce-vue';
import bootbox from 'bootbox';

export default {
  props: ['email_data', 'message_body', 'id'],
  components: {
    vueDropzone,
    VueTagsInput,
    'editor': Editor
  },
  data: function () {
    let table_id = this.getTableID();
    return {
      editor: null,
      table_id: table_id,
      separators: [';', ','],
      email: this.email_data,
      errors: {
        email: '',
        subject: '',
        message: '',
        cc: '',
        bcc: '',
        template: '',
      },
      dropOptions: {
        url: `/tables/${table_id}/buttons/email${this.id.length ? '/update' : ''}`,
        thumbnailWidth: 40, // px
        thumbnailHeight: 40,
        addRemoveLinks: false,
        maxFilesize: 25, // MB
        previewTemplate: this.template(),
        autoProcessQueue: false,
        parallelUploads: 10,
        uploadMultiple: true,
      },
      showDropZone: false,
      files: '',
      emails: [],
      message: '',
      hide_loading: true,
      hide_submit: true,
      tag: '',
      tags: [],
      templates: [],
      pdf_templates: [],
      mceEditor: {
        skin_url: "/tinymce/skins/ui/oxide",
        content_css: "/tinymce/skins/ui/oxide/content.min.css",
        language: $('meta[name="language"]').attr('content'),
        language_url: `/tinymce/langs/${$('meta[name="language"]').attr('content')}.js`,
        branding: false,
        height: 500,
        menubar: 'edit insert view format table tools help',
        relative_urls: false,
        paste_data_images: true,
        urlconverter_callback: function (url, node, on_save, name) {
          return url;
        },
        plugins: [
          "advlist autolink lists link image charmap print preview anchor",
          "searchreplace visualblocks code fullscreen",
          "insertdatetime media table paste",
          "image imagetools"
        ],
        toolbar: `undo redo | styleselect | bold italic | link | alignleft aligncenter alignright | link image | AddPlaceHolders | ChooseTemplate | AttachFiles | AttachPDFs`,
        image_list: "/template/images/logos",
        setup: (editor) => {
          this.editor = editor;
          editor.ui.registry.addButton('ChooseTemplate', {
            text: this.$t('choose_template'),
            onAction: () => {
              let templates = [{'text': this.$t('select_template'), value: ''}];
              this.templates.map((item) => {
                templates.push({
                  text: item.name,
                  value: item.id
                });
              });
              bootbox.prompt({
                title: this.$t('select_an_email_template'),
                buttons: {
                  confirm: {
                    label: this.$t('save'),
                  },
                  cancel: {
                    label: this.$t('cancel'),
                  }
                },
                inputType: 'select',
                inputOptions: templates,
                value: "",
                centerVertical: true,
                callback: (result) => {
                  if (result) {
                    let id = result;
                    if (id.length) {
                      this.email.template = id;
                      $.ajax({
                        type: 'GET',
                        url: '/template/content',
                        data: {
                          id
                        },
                        success: (res) => {
                          if (res) {
                            this.email.message = res.content;
                            if (res.subject && res.subject.length) {
                              this.email.subject = res.subject;
                            } else {
                              this.email.subject = "";
                            }

                            if (res.pdfs && res.pdfs.length) {
                              this.email.pdfs = res.pdfs.map(function (x) {
                                return parseInt(x, 10);
                              });
                            }

                            if (res.attachments && res.attachments.length) {
                              this.email.pdfs = res.attachments.map(function (x) {
                                return parseInt(x, 10);
                              });
                            }
                          }
                        }
                      });
                    }
                  }
                }
              });
            }
          });

          editor.ui.registry.addButton('AttachFiles', {
            text: this.$t('attach_files'),
            onAction: () => {
              $('#customdropzone').click();
            }
          });

          editor.ui.registry.addButton('AttachPDFs', {
            text: this.$t('attach_pdfs'),
            onAction: () => {
              $('#select-pdf-modal').modal('show');
            }
          });

          editor.ui.registry.addButton('AddPlaceHolders', {
            text: this.$t('add_placeholder'),
            onAction: () => {
              this.type = 'body';
              this.selectEmailField('body');
            }
          });
        }
      },
      other_errors: [
        'name', 'action', 'pages', 'button_position'
      ],
      fields: [],
      sub_fields: [],
      field: '',
      sub_field: '',
      type: '',
      delete_attachments: []
    }
  },
  mounted: function () {
    this.email.message = this.message_body;

    this.showDropZone = this.$refs.dropzone.getQueuedFiles().length > 0;

    let table_id = this.getTableID();

    if (table_id) {
      $.ajax({
        type: 'GET',
        url: '/email/templates',
        data: {
          table_id
        },
        success: (res) => {
          if (res.email.length) {
            this.templates = res.email;
          }

          if (res.pdf.length) {
            this.pdf_templates = res.pdf;
          }
        }
      });

      this.getTableFields(table_id);
    }
  },

  updated() {
    $(this.$refs.select).selectpicker({
      container: 'body'
    }).selectpicker('refresh');

    $(this.$refs.pdf_templates).selectpicker({
      container: 'body'
    }).selectpicker('refresh');
  },

  methods: {
    template: function () {
      return `<div class="dz-preview dz-file-preview">
                            <div class="dz-details">
                                <div>
                                    <div class="upload-details">
                                        <b><span data-dz-name></span></b>

                                        (<span data-dz-size></span>)

                                        <i class="fa fa-times remove-attachments" data-dz-remove></i>
                                    </div>

                                    <div class="upload-progress">
                                        <span class="dz-progress">
                                            <span class="dz-upload" data-dz-uploadprogress></span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="dz-error-message"><span data-dz-errormessage></span></div>
                            <div class="dz-success-mark"><i class="fa fa-check"></i></div>
                            <div class="dz-error-mark"><i class="fa fa-close"></i></div>
                        </div>`;
    },

    clearErrors() {
      this.errors = {
        email: '',
        subject: '',
        message: '',
        cc: '',
        bcc: '',
        template: ''
      };
      $('.button-error').empty();
    },

    clearEmailForm() {
      this.email = {
        sender: '',
        email: '',
        emails: [],
        subject: '',
        message: '',
        cc: '',
        ccs: [],
        bcc: '',
        bccs: [],
        template: '',
        pdfs: [],
        attachments: []
      };
      this.files = '';
      this.message = '';

      this.delete_attachments = [];
    },

    getEmailsFromTagsInput(emails) {
      let input = [];
      $(emails).each(function (i, email) {
        input.push(email.text);
      });
      return input.join(',');
    },

    getTableID() {
      return $('.create-button').attr('data-table-id');
    },

    handleEmailSubmit(e) {
      e.preventDefault();
      this.clearErrors();
      this.message = '';
      this.hide_loading = false;

      let formData = new FormData();
      formData.append('email', this.getEmailsFromTagsInput(this.email.emails));
      formData.append('cc', this.getEmailsFromTagsInput(this.email.ccs));
      formData.append('bcc', this.getEmailsFromTagsInput(this.email.bccs));
      formData.append('subject', this.email.subject);
      formData.append('message', this.email.message);
      formData.append('table_id', this.getTableID());
      formData.append('template', this.email.template);
      formData.append('pdfs', this.email.pdfs);
      formData.append('delete_attachments', this.delete_attachments);

      formData.append('name', $('#button-name').val());
      formData.append('action', $('#button-action').val());
      formData.append('pages', $('#button-pages').val());
      formData.append('button_position', $('#button-position').val());
      formData.append('icon_name', $('.icon-name').val());

      if (this.id.length) {
        formData.append('id', this.id);
      }

      if (!this.$refs.dropzone.getQueuedFiles().length) {

        formData.append('request_type', 'send');

        axios.post(`/tables/${this.getTableID()}/buttons/email${this.id.length ? '/update' : ''}`,
            formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
        ).then(sent => {
          if (sent) {
            this.clearEmailForm();
            this.hide_loading = true;
            window.location = `/tables/${this.getTableID()}/buttons`;
          }
        }).catch((err) => {
          let errors = err.response.data.errors;
          Object.keys(errors).forEach((key) => {
            if (this.other_errors.includes(key)) {
              console.log('render ' + key);
              $(`.button-error[data-name="${key}"]`).text(errors[key][0]);
            }
            this.errors[key] = errors[key][0];
          });
          this.hide_loading = true;
        });
      } else {
        formData.append('request_type', 'validate');
        axios.post(`/tables/${this.getTableID()}/buttons/email${this.id.length ? '/update' : ''}`,
            formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
        ).then(validated => {
          if (validated) {
            this.$refs.dropzone.processQueue();
          }
        }).catch((err) => {
          let errors = err.response.data.errors;
          Object.keys(errors).forEach((key) => {
            if (this.other_errors.includes(key)) {
              console.log('render ' + key);
              $(`.button-error[data-name="${key}"]`).text(errors[key][0]);
            }
            this.errors[key] = errors[key][0];
          });
          this.hide_loading = true;
        });
      }
    },

    attachFiles(e) {
      e.preventDefault();
      $('#customdropzone').click();
    },

    handleFileUploads() {
      this.files = this.$refs.files.files;
    },

    fileAdded(file) {
      this.showDropZone = true;
    },

    sendingEvent(file, xhr, formData) {
      formData.append('_token', $('meta[name="csrf-token"]').attr('content'));
      formData.append('request_type', 'send');
      formData.append('subject', this.email.subject);
      formData.append('message', this.email.message);
      formData.append('email', this.getEmailsFromTagsInput(this.email.emails));
      formData.append('cc', this.getEmailsFromTagsInput(this.email.ccs));
      formData.append('bcc', this.getEmailsFromTagsInput(this.email.bccs));
      formData.append('table_id', this.getTableID());
      formData.append('template', this.email.template);
      formData.append('pdfs', this.email.pdfs);
      formData.append('delete_attachments', this.delete_attachments);

      formData.append('name', $('#button-name').val());
      formData.append('action', $('#button-action').val());
      formData.append('pages', $('#button-pages').val());
      formData.append('button_position', $('#button-position').val());

      if (this.id.length) {
        formData.append('id', this.id);
      }
    },

    mailSent(response) {
      if (response) {
        this.clearEmailForm();
        this.message = this.$t('email_sent');
        this.showDropZone = false;
        this.$refs.dropzone.removeAllFiles();
        this.hide_loading = true;
        window.location = `/tables/${this.getTableID()}/buttons`;
      }
    },

    getUrlParameter(name) {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      let regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
          results = regex.exec(location.search);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    },

    preventTinyMCESubmit(e, editor) {
      e.preventDefault();
    },

    closeTemplateModal(e) {
      e.preventDefault();
      $('#select-pdf-modal').modal('hide');
    },

    triggerCancelButton(e) {
      e.preventDefault();
      let id = $('.create-button').attr('data-table-id');
      window.location = `/tables/${id}/buttons`;
    },

    selectEmailField(type) {
      this.type = type;
      $('#email-field-modal').modal('show');
    },

    closeEmailFieldModal(e) {
      $('#email-field-modal').modal('hide');
    },

    getTableFields(table_id) {
      $.ajax({
        type: 'GET',
        url: '/tablebuilder/getfields',
        data: {
          getfield: table_id
        },
        success: (res) => {
          this.fields = res.columns;
        }
      })
    },

    handleFieldChange(e) {
      let field = this.getFieldById(e.target.value);

      this.field = e.target.value;

      if (field.field_type === 'relationship') {
        $.ajax({
          type: 'GET',
          url: '/tablebuilder/getfields',
          data: {
            getfield: field.related_id
          },
          success: (res) => {
            this.sub_fields = res.columns;
          }
        })
      } else {
        this.sub_fields = [];
        this.sub_field = '';
      }
    },

    handleSubFieldChange(e) {
      let field = this.getSubFieldById(e.target.value);
      this.sub_field = e.target.value;
    },

    getFieldById(id) {
      let s_field;
      this.fields.map(field => {
        if (field.id === parseInt(id)) {
          s_field = field;
        }
      });
      return s_field;
    },

    getSubFieldById(id) {
      let s_field;
      this.sub_fields.map(field => {
        if (field.id === parseInt(id)) {
          s_field = field;
        }
      });
      return s_field;
    },

    appendField() {
      if (this.field.length) {
        let field = this.getFieldById(this.field);

        if (field.field_type === 'relationship') {
          if (this.sub_field.length) {
            let sub_field = this.getSubFieldById(this.sub_field);
            let name = `${field.name}.${sub_field.original_label}`;
            this.addFieldToInput(name, true);
            this.closeEmailFieldModal(null);
          } else {
            alert(this.$t('please_select_column'));
            return;
          }
        } else {
          this.addFieldToInput(field.name, false);
          this.closeEmailFieldModal(null);
        }
      } else {
        alert($t('pease_select_field'));
        return;
      }
    },

    addFieldToInput(input, relation = false) {
      if (this.type === 'to') {
        this.email.emails.push({
          'text': input
        });
      } else if (this.type === 'ccs') {
        this.email.ccs.push({
          'text': input
        });
      } else if (this.type === 'bccs') {
        this.email.bccs.push({
          'text': input
        });
      } else if (this.type === 'subject' || this.type === 'body') {
        if (relation) {
          let relation_field = input.split('.');
          input = `@relation{["${relation_field[0]}",${JSON.stringify(relation_field[1])}]}`
        } else {
          input = `\${${input}}`;
        }
        if (this.type === 'subject') {
          input = `${this.email.subject.length ? this.email.subject + ' ' : ''}${input}`;
          this.email.subject = input;
        } else if (this.type === 'body') {
          this.editor.insertContent(input);
        }
      }
    },

    removeAttachment(path) {
      this.email.attachments = this.email.attachments.filter(item => item !== path);
      this.delete_attachments.push(path);
    },

    fileRemoved(file, error, xhr) {
      if (!this.$refs.dropzone.getQueuedFiles().length) {
        this.showDropZone = false;
      }
    },

    removePDF(id) {
      this.email.pdfs = this.email.pdfs.filter(item => item !== id);
    }
  }
}
</script>
<template>
  <div class="mt-2 wrapper">

    <div v-bind:class="{ 'd-none' : hide_loading }" class="loader">
      <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
           x="0px" y="0px"
           width="40px" height="40px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
                  <path fill="#000"
                        d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z">
                      <animateTransform attributeType="xml"
                                        attributeName="transform"
                                        type="rotate"
                                        from="0 25 25"
                                        to="360 25 25"
                                        dur="0.6s"
                                        repeatCount="indefinite"/>
                  </path>
              </svg>
    </div>
    <form @submit="handleEmailSubmit" enctype="multipart/form-data">

      <div class="form-group row">
        <label class="col-sm-3 pt-2">{{ $t('to') }}</label>
        <div class="col-sm-9">
          <div class="row">
            <div class="col-sm-11">
              <vue-tags-input
                  v-model="email.email"
                  :tags="email.emails"
                  class="form-control w-100"
                  placeholder=""
                  @tags-changed="newTags => email.emails = newTags"
                  :addOnKey="[13, 188]"
                  :allowEditTags="true"
              />
            </div>
            <div class="col-sm-1">
              <div class="pt-2">
                <i class="far fa-plus-square pick-email-field" @click="selectEmailField('to')"></i>
              </div>
            </div>
          </div>
          <small v-if="errors.email.length" class="form-text text-danger">{{ errors.email }}</small>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-sm-3 pt-2">CC</label>
        <div class="col-sm-9">
          <div class="row">
            <div class="col-sm-11">
              <vue-tags-input
                  v-model="email.cc"
                  :tags="email.ccs"
                  class="form-control w-100"
                  placeholder=""
                  @tags-changed="newTags => email.ccs = newTags"
                  :addOnKey="[13, 188]"
                  :allowEditTags="true"
              />
            </div>
            <div class="col-sm-1">
              <div class="pt-2">
                <i class="far fa-plus-square pick-email-field" @click="selectEmailField('ccs')"></i>
              </div>
            </div>
          </div>
          <small v-if="errors.cc.length" class="form-text text-danger">{{ errors.cc }}</small>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-sm-3 pt-2">BCC</label>
        <div class="col-sm-9">
          <div class="row">
            <div class="col-sm-11">
              <vue-tags-input
                  v-model="email.bcc"
                  :tags="email.bccs"
                  class="form-control w-100"
                  placeholder=""
                  @tags-changed="newTags => email.bccs = newTags"
                  :addOnKey="[13, 188]"
                  :allowEditTags="true"
              />
            </div>

            <div class="col-sm-1">
              <div class="pt-2">
                <i class="far fa-plus-square pick-email-field" @click="selectEmailField('bccs')"></i>
              </div>
            </div>
          </div>
          <small v-if="errors.bcc.length" class="form-text text-danger">{{ errors.bcc }}</small>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-sm-3 pt-2">{{ $t('subject') }}</label>
        <div class="col-sm-9">
          <div class="row">
            <div class="col-sm-11">
              <input v-model="email.subject" type="text" class="form-control" placeholder="">
            </div>
            <div class="col-sm-1">
              <div class="pt-2">
                <i class="far fa-plus-square pick-email-field" @click="selectEmailField('subject')"></i>
              </div>
            </div>
          </div>
          <small v-if="errors.subject.length" class="form-text text-danger">{{ errors.subject }}</small>
        </div>
      </div>

      <div class="form-group">
        <editor
            api-key="no-api-key"
            :init="mceEditor"
            v-model="email.message"
            @onSubmit="preventTinyMCESubmit"
        ></editor>
        <small v-if="errors.message.length" class="form-text text-danger">{{ errors.message }}</small>
      </div>

      <div class="form-group">
        <div v-show="showDropZone || email.attachments.length">
          <div class="attachment-heading">
            {{ $t('email_attachments') }}
          </div>
        </div>
        <vue-dropzone
            v-show="showDropZone"
            id="customdropzone"
            ref="dropzone"
            :options="dropOptions"
            @vdropzone-file-added="fileAdded"
            @vdropzone-sending="sendingEvent"
            @vdropzone-success-multiple="mailSent"
            @vdropzone-removed-file="fileRemoved"
        ></vue-dropzone>

        <div v-for="path in email.attachments" class="display-pdfs" style="padding-left: 5px;">
          <b>
            {{ path.replace(/^.*[\\\/]/, '') }} <i class="fa fa-times remove-attachments"
                                                   @click="removeAttachment(path)"></i>
          </b>
        </div>

        <div class="pt-2">
          <div class="attachment-heading" v-show="email.pdfs.length">
            {{ $t('pdf_attachments') }}
          </div>

          <div v-for="l in pdf_templates" class="display-pdfs" v-show="email.pdfs.includes(l.id)">
            {{ l.name }} <i class="fa fa-times remove-attachments" @click="removePDF(l.id)"></i>
          </div>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-sm-3 pt-2"></label>
        <div class="col-sm-9">
          <div class="form-group">
            <button type="submit" id="submit-email-modal" class="btn btn-primary apply-btn-color">{{
                $t('save')
              }}
            </button>
            <button class="btn btn-dark" @click="triggerCancelButton">{{ $t('cancel') }}</button>
          </div>
        </div>
      </div>

      <!-- Modal -->
      <div class="modal fade" id="select-pdf-modal" tabindex="-2" role="dialog" aria-labelledby="select-pdf-modal"
           aria-hidden="true">
        <div class="modal-dialog modal-sm modal-dialog-scrollable modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="select-pdf-title">{{ $t('select_pdfs') }}</h5>
            </div>
            <div class="modal-body" id="select-pdf-body">
              <select data-style="btn-secondary"
                      class="form-control selectpicker"
                      ref="pdf_templates" v-model="email.pdfs"
                      multiple>
                <option v-for="l in pdf_templates" :value="l.id">{{ l.name }}</option>
              </select>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary apply-btn-color" id="select-pdf-email"
                      @click="closeTemplateModal">{{ $t('close') }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal -->
      <div class="modal fade" id="email-field-modal" tabindex="-2" role="dialog" aria-labelledby="select-pdf-modal"
           aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ $t('select_field') }}</h5>
            </div>
            <div class="modal-body">
              <select data-style="btn-secondary"
                      class="form-control"
                      v-model="field"
                      @change="handleFieldChange">
                <option v-for="l in fields" :value="l.id">{{ l.label }}</option>
              </select>

              <h5 v-show="sub_fields.length" class="mt-2"> {{ $t('select_columns') }} </h5>

              <select data-style="btn-secondary"
                      v-show="sub_fields.length"
                      v-model="sub_field"
                      class="form-control mt-2"
                      @change="handleSubFieldChange">
                <option v-for="l in sub_fields" :value="l.id">{{ l.label }}</option>
              </select>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary apply-btn-color" @click="closeEmailFieldModal">{{
                  $t('close')
                }}
              </button>
              <button type="button" class="btn btn-dark apply-btn-color" @click="appendField">{{
                  $t('select_field')
                }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div v-if="message.length" class="alert alert-success">{{ message }}</div>
  </div>
</template>